import styled from 'styled-components';
import { FlexColumn, FlexRow, TableData } from '@make-software/cspr-design';
import React from 'react';
import { BodyText } from '@block-explorer/ui';
import DetailsTableRow from '../details-table-row/details-table-row';

const StyledTableData = styled(TableData)(({ theme }) => ({
  width: '100%',
  padding: '16px 8px',
}));

const StyledFlexRowFeedItem = styled(FlexRow)(({ theme }) => ({
  height: '24px',
}));

const StyledFlexRowContent = styled(FlexRow)(({ theme }) => ({
  wordBreak: 'break-all',
}));

export const FeedInfoSectionItem = ({
  title,
  renderContent,
  renderAction,
}: {
  title: string;
  renderContent?: React.JSX.Element;
  renderAction?: React.JSX.Element;
}) => {
  return (
    <DetailsTableRow>
      <StyledTableData>
        <FlexColumn gap={4}>
          <StyledFlexRowFeedItem align={'center'}>
            <BodyText size={3} scale={'xs'} variation={'darkGray'}>
              {title}
            </BodyText>
          </StyledFlexRowFeedItem>
          <FlexRow justify={'space-between'} align={'center'}>
            <StyledFlexRowContent>{renderContent}</StyledFlexRowContent>
            {renderAction ? <FlexRow>{renderAction}</FlexRow> : null}
          </FlexRow>
        </FlexColumn>
      </StyledTableData>
    </DetailsTableRow>
  );
};

export default FeedInfoSectionItem;
